// removed by extract-text-webpack-plugin
module.exports = {"picker":"TodayPicker-picker"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdatepicker/TodayPicker.scss
// module id = 363
// module chunks = 0